import React from 'react';
import {
    ResponsiveContainer, LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend
} from 'recharts';
import CustomTooltip from "./components/CustomTooltip";
import numeral from 'numeral';

const Graph = ({ data }) => {
    return (
        <ResponsiveContainer width={'100%'} height={300}>
            <LineChart
                width={500}
                height={300}
                data={data}
                margin={{
                    top: 5, right: 10, left: 10, bottom: 5,
                }}
            >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="time" />
                <YAxis yAxisId="left" tickFormatter={(number) => numeral(number).format('0.000a')}/>
                <YAxis yAxisId="right" orientation="right"/>
                <Tooltip content={CustomTooltip}/>
                <Legend/>
                <Line yAxisId="left" type="linear" dataKey="requests" stroke="#ff0000" dot={{ stroke: '#ff0000', strokeWidth: 1 }} activeDot={{ stroke: '#ff0000', strokeWidth: 1 }} strokeWidth={1}/>
                <Line yAxisId="left" type="linear" dataKey="responses" stroke="#008000" dot={{ stroke: '#008000', strokeWidth: 1 }} activeDot={{ stroke: '#008000', strokeWidth: 1 }} strokeWidth={1} />
                <Line yAxisId="right" type="linear" dataKey="responseTime" stroke="#5c00e6" dot={{ stroke: '#5c00e6', strokeWidth: 1 }} activeDot={{ stroke: '#5c00e6', strokeWidth: 1 }} strokeWidth={1} />
            </LineChart>
        </ResponsiveContainer>
    );
}

export default Graph;


// WEBPACK FOOTER //
// ./src/scenes/BidderSourcesGraph/components/Graph/index.js